import makeStyles from "@material-ui/core/styles/makeStyles";

export const useStyles = (theme) =>
    makeStyles(() => ({
        button: {
            display: "inline-flex",
            verticalAlign: "bottom",
            justifyContent: "center",
            alignItems: "center",

            fontFamily: theme.button.common.fontFamily,
            fontSize: theme.button.common.fontSize,
            fontWeight: theme.button.common.fontWeight,
            borderRadius: theme.button.common.borderRadius,

            "&:disabled": {
                cursor: "not-allowed",
            },
        },

        defaultVariant: {
            color: theme.button.default.color,
            border: `1px solid ${theme.button.default.borderColor}`,
            backgroundColor: theme.button.default.backgroundColor,

            "&:focus": {
                outline: theme.button.common.focus.outline,
                outlineOffset: theme.button.common.focus.outlineOffset,
            },

            "&:hover": {
                color: theme.button.default.hover.color,
                backgroundColor: theme.button.default.hover.backgroundColor,
                borderColor: theme.button.default.hover.borderColor,
            },

            "&:active": {
                color: theme.button.default.active.color,
                backgroundColor: theme.button.default.active.backgroundColor,
                borderColor: theme.button.default.active.borderColor,
            },

            "&:disabled": {
                color: theme.button.default.disabled.color,
                backgroundColor: theme.button.default.disabled.backgroundColor,
                borderColor: theme.button.default.disabled.borderColor,
            },
        },
        primaryVariant: {
            color: theme.button.primary.color,
            border: `1px solid ${theme.button.primary.borderColor}`,
            backgroundColor: theme.button.primary.backgroundColor,

            "&:focus": {
                outline: theme.button.common.focus.outline,
                outlineOffset: theme.button.common.focus.outlineOffset,
            },

            "&:hover": {
                color: theme.button.primary.hover.color,
                backgroundColor: theme.button.primary.hover.backgroundColor,
                borderColor: theme.button.primary.hover.borderColor,
            },

            "&:active": {
                color: theme.button.primary.active.color,
                backgroundColor: theme.button.primary.active.backgroundColor,
                borderColor: theme.button.primary.active.borderColor,
            },

            "&:disabled": {
                color: theme.button.primary.disabled.color,
                backgroundColor: theme.button.primary.disabled.backgroundColor,
                borderColor: theme.button.primary.disabled.borderColor,
            },
        },
        actionVariant: {},
        subtleVariant: {},

        defaultSize: {
            padding: `${theme.tokens.spacings.s10} ${theme.tokens.spacings.s16}`,
        },
        smallSize: {
            padding: `${theme.tokens.spacings.s6} ${theme.tokens.spacings.s3}`,
        },
        largeSize: {
            padding: `${theme.tokens.spacings.s10} ${theme.tokens.spacings.s24}`,
        },

        loading: {
            width: "100px",
            paddingTop: theme.tokens.spacings.s12,
            paddingBottom: theme.tokens.spacings.s12,
        },
    }))();
